import { useEffect } from 'react';

// Module-level counter so multiple simultaneous modals don't race on the attribute.
let openCount = 0;

export function useModalBodyFlag(isOpen: boolean) {
  useEffect(() => {
    if (!isOpen) return;
    openCount++;
    document.body.setAttribute('data-modal-open', 'true');
    return () => {
      openCount--;
      if (openCount <= 0) {
        openCount = 0;
        document.body.removeAttribute('data-modal-open');
      }
    };
  }, [isOpen]);
}
